if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();

})();


document.addEventListener('DOMContentLoaded', () => {

    /* Main Nav Dropdown */
    let primaryNav = document.getElementById('primary-nav');
    if(primaryNav){
        primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
            primary_nav.addEventListener("mouseover", () => {
                primary_nav.classList.add('hover');
                if(primary_nav.querySelector('ul.submenu')){
                    primary_nav.querySelector('ul.submenu').classList.add('open');
                }
            });
            primary_nav.addEventListener("mouseout", () => {
                primary_nav.classList.remove('hover');
                if(primary_nav.querySelector('ul.submenu')){
                    primary_nav.querySelector('ul.submenu').classList.remove('open');
                }
            });
        });
    }
    
    console.log( document.querySelectorAll(".navigation .submenu"));


    document.querySelectorAll(".navigation .submenu").forEach(submenu => {
        let overviewText = submenu.parentElement.previousElementSibling.textContent;
        let overviewLink = submenu.parentElement.previousElementSibling.getAttribute("href");
        submenu.insertAdjacentHTML("afterbegin", `<li><a href="${overviewLink}" aria-label="${overviewText} Overview">Overview</a></li>`)
        })

});
